// @flow
import * as React from 'react';
import type { Balance } from '../balance/balance.types.js';

type Props = {|
  payer: $ElementType<ReduxState, 'payer'>,
  organization: $ElementType<ReduxState, 'organization'>,
  payerBalance: Balance
|};

class PayerNameBlock extends React.Component<Props> {
  render() {
    const { payer, organization, payerBalance } = this.props;

    return (
      <div className="payer-name-block-wrap">
        <div className="payer-name-block">
          {payer.roles ? (
            <div className="payer-roles">
              {payer.roles.map(role => {
                return (
                  <span key={role} className="payer-roles-item">
                    {role}
                  </span>
                );
              })}
            </div>
          ) : null}
          <span className="payer-name">
            {payer.name} {payer.middlename} {payer.surname}
          </span>
        </div>
        <div className="payer-balance-item-wrap">
          <div className="payer-balance-item">
            <span className="payer-balance-item-label">Balance in {organization.name}</span>
            <span className="payer-balance">${payerBalance.balance}</span>
          </div>
          <div className="payer-balance-item">
            <span className="payer-balance-item-label">Unpaid Invoices Total</span>
            <span className="payer-balance">${payerBalance.unpaidTotal}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default PayerNameBlock;
